import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { ServicenowService } from '../../service';

export type TicketsExportConfig = typeof TicketsExportConfig._.Config;

export const TicketsExportConfig = IntegrationConfig.make({
  service: ServicenowService,
  name: Integration_Handler_Names_Enum.TicketsExport,
  configSchema: z.object({
    table: z.string().min(1),
    query: z.string().min(1),
    fields: z.array(z.string().min(1)).optional(),
  }),
});
